export default __webpack_public_path__ + "static/media/Ellipse 2112.1e936d04.svg";